/**
 * Mobile Product Faq Item Toggle
 */
const mobileProductFaqItemToggle = () => {
	$('.product-faq__item').on('click', function(event) {
		const $this = $(this);
		const $parent = $this.closest('.product-faq');
		const $body = $this.find('.product-faq__item-body');
		const isMobileScreen = $(window).innerWidth() <= 1023;
		const isCurrentClass = $this.hasClass('is-current');

		if (! isCurrentClass && isMobileScreen) {
			$parent
				.find('.product-faq__item')
				.removeClass('is-current')
				.find('.product-faq__item-body')
				.slideUp();

			$this.addClass('is-current');

			$body.slideDown();

			event.preventDefault();
		}
	});
}

mobileProductFaqItemToggle();
